import { useMemo } from 'react';
export function findNearestRouteComponent(component) {
    const traverse = (component) => {
        return component.type === 'route'
            ? component
            : component.parent && traverse(component.parent);
    };
    return component && traverse(component);
}
/**
 * Traverse up to find nearest route component
 */
export function useFindNearestRouteComponent(component) {
    return useMemo(() => findNearestRouteComponent(component), [component]);
}
//# sourceMappingURL=useFindNearestRouteComponent.js.map